import { render } from "./video_markup_player.vue?vue&type=template&id=669dc8b8"
import script from "./video_markup_player.vue?vue&type=script&lang=js"
export * from "./video_markup_player.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__